// import distributorService from "app/services/distributorService";
// import memberService from "app/services/memberService";
// import React, { Component } from "react";
// import AsyncSelect from "react-select/async";

// const { getDistributor ,getMerchants} = distributorService;
// class MerchantAutocomplete extends Component {
//   constructor() {
//     super();
//     this.state = {
//       selectedValue: null,
//       searchText: "",
//     };
//   }
//   customStyles = {
//     control: (base) => ({
//       ...base,
//       height: 34,
//       minHeight: 34,
//       //width: 250,
//     }),
//   };
//   // handle input change event
//   handleInputChange = (value) => {
//     this.setState({ searchText: value });
//   };

//   handleChange = (value) => {
//     this.setState({ selectedValue: value });
//     this.props.setFieldValue("memberId", value.id);
//     this.props.handleChangeOptions(value.id);
//   };
//   refreshFilter = () => {
//     this.props.refreshFilter();
//   };
//   // load options using API call
//   loadOptions = async (value) => {
//     //const searchText = value.trim().toLowerCase();
//     const { data } = await getMerchants(value);
//     // console.log(data);
//     const memberData = [];
//     if (data?.data?.length > 0) {
//       data.data.map((item) =>
//         memberData.push({
//           id: item.memId,
//           label: `${item.uniqueIdentity} - ${item.company}`,
//         })
//       );
//     }
//     // - ${item.memberMobileNo}
//     return memberData;
//   };

//   render() {
//     return (
//       <AsyncSelect
//         cacheOptions
//         defaultOptions
//         value={this.state.selectedValue}
//         getOptionLabel={(e) => e.label}
//         getOptionValue={(e) => e.id}
//         loadOptions={this.loadOptions}
//         onInputChange={this.handleInputChange}
//         onChange={this.handleChange}
//         name="memberId"
//         styles={this.customStyles}
//       />
//     );
//   }
// }
// export default MerchantAutocomplete;

import React, { useState } from "react";
import AsyncSelect from "react-select/async";
import { getMerchants } from "app/services/distributorService";

const MerchantAutocomplete = (props) => {
  const [selectedValue, setSelectedValue] = useState(null);
  const [searchText, setSearchText] = useState("");

  const customStyles = {
    control: (base) => ({
      ...base,
      height: 34,
      minHeight: 34,
      //width: 250,
    }),
  };

  // handle input change event
  const handleInputChange = (value) => {
    setSearchText(value);
  };

  const handleChange = (value) => {
    setSelectedValue(value);
    props.setFieldValue("memberId", value.id);
    props.handleChangeOptions(value.id);
  };

  // const refreshFilter = () => {
  //   props.refreshFilter();
  // };

  // load options using API call
  const loadOptions = async (value) => {
    const { data } = await getMerchants(value);
    const memberData = [];
    if (data?.data?.length > 0) {
      data.data.map((item) =>
        memberData.push({
          id: item.memId,
          label: `${item.uniqueIdentity} - ${item.company}`,
        })
      );
    }
    return memberData;
  };

  return (
    <AsyncSelect
      cacheOptions
      defaultOptions
      value={selectedValue}
      getOptionLabel={(e) => e.label}
      getOptionValue={(e) => e.id}
      loadOptions={loadOptions}
      onInputChange={handleInputChange}
      onChange={handleChange}
      name="memberId"
      styles={customStyles}
    />
  );
};

export default MerchantAutocomplete;
